// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_jw-5";
export var filledCircle = "_jw-4";
export var historyEntry = "_jw-3";
export var messageSideLeft = "_jw-1";
export var messageSideRight = "_jw-2";
export var orderTrackingCarouselWrapper = "_jw-6";
export var orderTrackingInfoContainer = "_jw-0";